window._define('common/errorFactory', function () { 'use strict';
    var Exceptions = {};

    function createException(name) {
        var Exception = function (message) {
            this.name = name;
            this.message = (message || '');
        };

        try {
            Exception.prototype = Object.create(Error.prototype);
            Exception.prototype.constructor = Exception;
        } catch (e) {
            Exception.prototype = new Error();
        }

        return Exception;
    }

    function errorFactory(name) {
        var Exception = Exceptions[name];

        if (!Exception) {
            Exception = createException(name);
        }

        return Exception;
    }

    return errorFactory;
});
